import axios from "axios";
import { endpoint } from "../../config";
import { customToast } from "../../lib/toastLib";

const CcOffersApi = async (app_id) => {
  try {
    const apiLink = `${endpoint}/api/formula-cc/${app_id}`;
    const response = await axios.get(apiLink);
    const data = response.data;

    const dataArray = [];
    if (data) {
      data.forEach((lender) => {
        const offers = Object.values(lender.offers).map((offerObj) => {
          console.log("offers",offerObj)  
          return {
            loanAmount: offerObj.offer_amount,
            tenure: offerObj.offer_tenure,
            interestRate: offerObj.offer_roi,
            interestRateText: offerObj.offer_roi_text,
            processingFees: offerObj.offer_pf,
            logo: offerObj.logo,
            navigationLink: offerObj.url,
            preapproved: offerObj.preapproved,
            specialOffer : offerObj.special_offer
          };
        });
        offers.forEach((offerObj) => {
          offerObj.name = lender.lender_name;

          dataArray.push(offerObj);
        });
      });
    }

    return dataArray;
  } catch (error) {
    if (error.response) {
      customToast.error(error.response.data?.message);
    } else {
      customToast.error(error.message);
    }
    throw error;
  }
};

export default CcOffersApi;
